import React from 'react';
import { Box } from '@mui/material';
import LanguagePicker from './LanguagePicker';

const FloatingLanguagePicker = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 10,
        right: 20,
        zIndex: 1000,
        backgroundColor: 'white',
        borderRadius: 2,
        padding: '4px 8px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
      }}>
      <LanguagePicker />
    </Box>
  );
};

export default FloatingLanguagePicker;
